/** @jsx jsx */

import { Icon } from '@zapier/design-system';
import {
  ServiceIconShell,
  ZapierLogoSymbol,
} from '@zapier/design-system-patterns';
import { css, jsx } from '@emotion/core';

const sizeMap = {
  150: 120 as const,
  120: 80 as const,
  80: 60 as const,
  60: 40 as const,
  40: 30 as const,
  30: 20 as const,
  20: 20 as const,
};

const Styles = {
  wrapper: css`
    display: flex;
  `,
};

type Props = {
  hasWhiteBackground: boolean;
  isSymbol: boolean;
  size: 20 | 30 | 40 | 60 | 80 | 120 | 150;
};

function DefaultServiceIcon(props: Props) {
  const { hasWhiteBackground, isSymbol, size } = props;

  return (
    <ServiceIconShell hasWhiteBackground={hasWhiteBackground} size={size}>
      <span css={Styles.wrapper} title="Logo placeholder">
        {isSymbol ? (
          <ZapierLogoSymbol size={sizeMap[size]} />
        ) : (
          <Icon name="zapierLogo" size={sizeMap[size]} />
        )}
      </span>
    </ServiceIconShell>
  );
}

export default DefaultServiceIcon;
